import { Accordion, Card, Col, ProgressBar } from "react-bootstrap";
import { FaChevronDown } from "react-icons/fa";
import { capitalize } from "../../../../../../utils/helpers";
const ResultsSection = ({
  data,
  type
}) => {
  return <Col className="ideacheckerresults" style={{
    paddingRight: "0px"
  }}>
      <Accordion className="companyaccordion" defaultActiveKey="resultstats">
        <Accordion.Item eventKey="resultstats">
          <Accordion.Header className="companycardheader">
            <div className="companytitlecard">Results</div>

            <div className="companyarrowiconright">
              <FaChevronDown className="arrow-icon" />
            </div>
          </Accordion.Header>
          <Accordion.Body style={{
          fontFamily: "AileronRegular"
        }}>
              <div style={{
            fontWeight: "bold",
            fontSize: "18px",
            textAlign: "center",
            marginBottom: "10px"
          }}>
                {capitalize(type)} score:{" "}
                {data?.[type].score ? data[type].score <= 0 ? 0 : data[type].score : 0}
                %
              </div>

              {data?.[type].score < 50 ? <ProgressBar now={data?.[type].score ? data[type].score : 0} variant="danger" style={{
            height: "2rem"
          }} /> : <ProgressBar now={data?.[type].score ? data[type].score : 0} variant="success" style={{
            height: "2rem"
          }} />}

              <br />

              {/* {
                                    (data?.error)
                                        ? (<Alert className="error-message" variant="danger" style={{ marginBottom: "0" }}>
                                            {data.error}
                                        </Alert>)
                                        : ""
                                } */}

              {type === "overall" && <>
                  <br />
                  <span style={{
              fontWeight: "bold",
              fontSize: "14px"
            }}>
                    How do we analyze your business plan?
                  </span>

                  <br />

                  <div style={{
              fontSize: "14px",
              paddingTop: "4%"
            }}>
                    <div style={{
                width: "100%",
                display: "flex",
                flexDirection: "row"
              }}>
                      <p style={{
                  width: "80%",
                  marginBottom: "0"
                }}>
                        Business
                      </p>
                      <p style={{
                  width: "20%",
                  marginBottom: "0",
                  textAlign: "right"
                }}>
                        {data?.business.score ? data.business.score > 0 ? data.business.score : 0 : 0}
                        %
                      </p>
                    </div>
                    <ProgressBar now={data?.business.score ? data.business.score : 0} variant="danger" style={{
                height: "0.2rem"
              }} />
                  </div>

                  <div style={{
              fontSize: "14px",
              paddingTop: "4%"
            }}>
                    <div style={{
                width: "100%",
                display: "flex",
                flexDirection: "row"
              }}>
                      <p style={{
                  width: "80%",
                  marginBottom: "0"
                }}>
                        Solution
                      </p>
                      <p style={{
                  width: "20%",
                  marginBottom: "0",
                  textAlign: "right"
                }}>
                        {data?.solution.score ? data.solution.score > 0 ? data.solution.score : 0 : 0}
                        %
                      </p>
                    </div>
                    <ProgressBar now={data?.solution.score ? data.solution.score : 0} variant="danger" style={{
                height: "0.2rem"
              }} />
                  </div>

                  <div style={{
              fontSize: "14px",
              paddingTop: "4%"
            }}>
                    <div style={{
                width: "100%",
                display: "flex",
                flexDirection: "row"
              }}>
                      <p style={{
                  width: "80%",
                  marginBottom: "0"
                }}>Market</p>
                      <p style={{
                  width: "20%",
                  marginBottom: "0",
                  textAlign: "right"
                }}>
                        {data?.market.score ? data.market.score > 0 ? data.market.score : 0 : 0}
                        %
                      </p>
                    </div>
                    <ProgressBar now={data?.market.score ? data.market.score : 0} variant="danger" style={{
                height: "0.2rem"
              }} />
                  </div>

                  <div style={{
              fontSize: "14px",
              paddingTop: "4%"
            }}>
                    <div style={{
                width: "100%",
                display: "flex",
                flexDirection: "row"
              }}>
                      <p style={{
                  width: "80%",
                  marginBottom: "0"
                }}>
                        Competition
                      </p>
                      <p style={{
                  width: "20%",
                  marginBottom: "0",
                  textAlign: "right"
                }}>
                        {data?.competition.score ? data.competition.score > 0 ? data.competition.score : 0 : 0}
                        %
                      </p>
                    </div>
                    <ProgressBar now={data?.competition.score ? data.competition.score : 0} variant="danger" style={{
                height: "0.2rem"
              }} />
                  </div>

                  <div style={{
              fontSize: "14px",
              paddingTop: "4%"
            }}>
                    <div style={{
                width: "100%",
                display: "flex",
                flexDirection: "row"
              }}>
                      <p style={{
                  width: "80%",
                  marginBottom: "0"
                }}>
                        Operations
                      </p>
                      <p style={{
                  width: "20%",
                  marginBottom: "0",
                  textAlign: "right"
                }}>
                        {data?.operations.score ? data.operations.score > 0 ? data.operations.score : 0 : 0}
                        %
                      </p>
                    </div>
                    <ProgressBar now={data?.operations.score ? data.operations.score : 0} variant="danger" style={{
                height: "0.2rem"
              }} />
                  </div>

                  <div style={{
              fontSize: "14px",
              paddingTop: "4%"
            }}>
                    <div style={{
                width: "100%",
                display: "flex",
                flexDirection: "row"
              }}>
                      <p style={{
                  width: "80%",
                  marginBottom: "0"
                }}>
                        Marketing
                      </p>
                      <p style={{
                  width: "20%",
                  marginBottom: "0",
                  textAlign: "right"
                }}>
                        {data?.marketing.score ? data.marketing.score > 0 ? data.marketing.score : 0 : 0}
                        %
                      </p>
                    </div>
                    <ProgressBar now={data?.marketing.score ? data.marketing.score : 0} variant="danger" style={{
                height: "0.2rem"
              }} />
                  </div>

                  <div style={{
              fontSize: "14px",
              paddingTop: "4%"
            }}>
                    <div style={{
                width: "100%",
                display: "flex",
                flexDirection: "row"
              }}>
                      <p style={{
                  width: "80%",
                  marginBottom: "0"
                }}>
                        Financials
                      </p>
                      <p style={{
                  width: "20%",
                  marginBottom: "0",
                  textAlign: "right"
                }}>
                        {data?.financials.score ? data.financials.score > 0 ? data.financials.score : 0 : 0}
                        %
                      </p>
                    </div>
                    <ProgressBar now={data?.financials.score ? data.financials.score : 0} variant="danger" style={{
                height: "0.2rem"
              }} />
                  </div>

                  <div style={{
              fontSize: "14px",
              paddingTop: "4%"
            }}>
                    <div style={{
                width: "100%",
                display: "flex",
                flexDirection: "row"
              }}>
                      <p style={{
                  width: "80%",
                  marginBottom: "0"
                }}>Risk</p>
                      <p style={{
                  width: "20%",
                  marginBottom: "0",
                  textAlign: "right"
                }}>
                        {data?.risk.score ? data.risk.score > 0 ? data.risk.score : 0 : 0}
                        %
                      </p>
                    </div>
                    <ProgressBar now={data?.risk.score ? data.risk.score : 0} variant="danger" style={{
                height: "0.2rem"
              }} />
                  </div>
                </>}

              {/* <div style={{ fontSize: "14px", paddingTop: "4%" }}>
                                    <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                                        <p style={{ width: "80%", marginBottom: "0" }}>Management</p>
                                        <p style={{ width: "20%", marginBottom: "0", textAlign: "right" }}>
                                            {data?.management.score
                                                ? data.management.score > 0
                                                    ? data.management.score
                                                    : 0
                                                : 0}%
                                        </p>
                                    </div>
                                    <ProgressBar now={data?.management.score ? data.management.score : 0} variant="danger" style={{ height: "0.2rem" }} />
                                </div> */}
            </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <Accordion defaultActiveKey="notification" style={{
      marginTop: "10px"
    }}>
        <Accordion.Item eventKey="notification">
          <Accordion.Header className="companycardheader">
            <div className="companytitlecard">Notification</div>

            <div className="companyarrowiconright">
              <FaChevronDown className="arrow-icon" />
            </div>
          </Accordion.Header>
          <Accordion.Body style={{
          fontFamily: "AileronRegular"
        }}>
              <span className="info-notes" style={{
            fontSize: "16px"
          }}>
                Note:
                <ul style={{
              paddingLeft: "17px"
            }}>
                  <li id="notes-points">
                    Write no less than 2 words for short answers
                  </li>
                  <li id="notes-points">
                    Write more than 7 words for normal answers
                  </li>
                  <li id="notes-points">
                    Due to large datasets, it may take up to 1 min to compute
                    and show results.
                  </li>
                  <li id="notes-points">
                    We use advanced real-time analytics and text analytics to
                    analyze your inputs.
                  </li>
                </ul>
              </span>
            </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <Accordion defaultActiveKey="feedback" style={{
      marginTop: "10px"
    }}>
        <Accordion.Item eventKey="feedback">
          <Accordion.Header className="companycardheader">
            <div className="companytitlecard">Feedback</div>

            <div className="companyarrowiconright">
              <FaChevronDown className="arrow-icon" />
            </div>
          </Accordion.Header>
          <Accordion.Body style={{
          fontFamily: "AileronRegular"
        }}>
              {!data ? "" : <div className="pitchdeckrecommended">
                  Recommended readings:
                  <ul style={{
              paddingLeft: "17px"
            }}>
                    {data?.[type === "overall" ? "overview" : type].recommended_read.map((reading, index) => <li key={index}>
                        <a href={reading.LINK} target="_blank" rel="noopener noreferrer">
                          {reading.TITLE}
                        </a>
                      </li>)}
                  </ul>
                </div>}
            </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Col>;
};
export default ResultsSection;